import api from "./api";

/**
 * Login
 * @param {string} username
 * @param {string} password
 */
export const loginApi = (username, password) => {
  return api.post("/api/login", {
    username,
    password,
  });
};

export const getBalanceApi = () => {
  return api.get("/api/user/balance");
};

/**
 * get vendors
  * @param {Object} options
 */
export const getVendorsApi = ({
  userId = null,
  type = null,
} = {}) => {

   const params = {
    ...(userId && { user_id: userId }),
    ...(type && { type })
  };
  return api.get("/api/vendors", {params});
};

/**
 * Get games (pagination + search + type)
* @param {Object} options
 */
export const getGamesApi = ({
  userId = null,
  page = 1,
  perPage = 10,
  search = "",
  type = null,
  vendor = null,
  pageType = null
} = {}) => {
  const params = {
    ...(userId && { user_id: userId }),
    ...(page && { page }),
    ...(perPage && { perPage: perPage }),
    ...(search && { search }),
    ...(type && { type }),
    ...(vendor && { vendor }),
    ...(pageType && { pageType }),
  };
  return api.get("/api/games", { params });
}

/**
 * Play game
 * @param {string} gameCode
 * @param {string} vendorCode
 */
export const playGameApi = (gameCode, vendorCode) => {
  return api.post("/api/playgame", {
    gameCode,
    vendorCode,
  });
};

export const echoAuthApi = (socketId, channelName) => {
  return api.post("/api/broadcasting/auth", {
    socket_id: socketId,
    channel_name: channelName,
  });
};